import { render, staticRenderFns } from "./Step8.vue?vue&type=template&id=2cf85c95&scoped=true&"
import script from "./Step8.vue?vue&type=script&lang=js&"
export * from "./Step8.vue?vue&type=script&lang=js&"
import style0 from "./Step8.vue?vue&type=style&index=0&id=2cf85c95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf85c95",
  null
  
)

export default component.exports